import { render, staticRenderFns } from "./android12.vue?vue&type=template&id=3982e397&scoped=true"
import script from "./android12.vue?vue&type=script&lang=js"
export * from "./android12.vue?vue&type=script&lang=js"
import style0 from "./android12.vue?vue&type=style&index=0&id=3982e397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3982e397",
  null
  
)

export default component.exports